<div>
  <div class="form-row">
    <div class="col-12">
      <address-lines
        [addressFormGroup]="formGroup.get('address')"
        [isShowErrors]="isShowErrors"
        [isShowRequired]="isShowRequired"
      ></address-lines>
    </div>
  </div>
  <div class="form-row">
    <div class="col-12 col-sm-6">
      <!-- city -->
      <app-control-wrapper [control]="addressFormGroup.get('city')" [errors]="errors.city">
        <label for="city" control-label>
          {{ "LABELS.CITY" | translate }}
        </label>
        <input
          type="text"
          [formControl]="addressFormGroup.get('city')"
          class="form-control"
          id="city"
          name="city"
          [dropSpecialCharacters]="false"
          [patterns]="CUSTOM_MASK"
          [mask]="'F*'"
          [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
          control-wrapper
        />
      </app-control-wrapper>
    </div>

    <div class="col-12 col-sm-6">
      <!-- country -->
      <!-- solution to support disabling, due to non-clear old legacy-->
      <country-dropdown
        *ngIf="isForeignCompany"
        [fc]="formGroup.get(['address', 'country'])"
        [errors]="errors.country"
        [defaultCountry]="null"
        [isDisabled]="false"
        [isFilterRestrictedCountries]="isFilterRestrictedCountries"
      ></country-dropdown>

      <country-dropdown
        *ngIf="!isForeignCompany"
        [fc]="formGroup.get(['address', 'country'])"
        [errors]="errors.country"
        [defaultCountry]="defaultCountry"
        [isDisabled]="isAllowCountryDisable"
        [isFilterRestrictedCountries]="isFilterRestrictedCountries"
      ></country-dropdown>
    </div>
  </div>
  <div class="form-row" *ngIf="isShowState">
    <div class="col-12 col-sm-6">
      <!-- state -->
      <state-dropdown
        [countryFc]="addressFormGroup.get('country')"
        [stateFc]="addressFormGroup.get('state')"
        [errors]="errors.state"
      ></state-dropdown>
    </div>
    <div class="col-12 col-sm-6">
      <!-- postal code -->

      <app-control-wrapper
        [control]="addressFormGroup.get('postalCode')"
        [errors]="errors.postalCode"
        [helper]="isForeignCountry ? null : 'FORM_HELPER.POSTAL_CODE'"
      >
        <label for="postalCode" control-label>
          {{ "FORM_LABEL.POSTALCODE" | translate }}
        </label>
        <input
          type="text"
          inputmode="decimal"
          [formControl]="addressFormGroup.get('postalCode')"
          class="form-control"
          id="postalCode"
          name="postalCode"
          [mask]="isForeignCountry ? 'A{9}' : '0{9}'"
          [patterns]="CUSTOM_MASK"
          [appMaskErrorTooltip]="isForeignCountry ? 'MASK_ERROR.ONLY_ENGLISH_DIGITS' : integerInputMap.maskErrorTooltip"
          [maxMaskLength]="9"
          control-wrapper
        />
      </app-control-wrapper>
    </div>
  </div>
</div>
